import type { AttendanceLocation } from '../api/attendance';

export function locationLabel(location: AttendanceLocation | null | undefined, fallback = 'Work site'): string {
  if (!location) return fallback;
  if (location.siteName) return location.siteName;
  return fallback;
}

export function hasMapLink(location: AttendanceLocation | null | undefined): location is AttendanceLocation & { mapUrl: string } {
  return Boolean(location?.mapUrl);
}
